export default "__VITE_ASSET__KUp7yMuJ__"